<template>
<div>
    <b-card style="padding: 10px 30px 30px;" no-body>
        <div class="position-relative image-side ">
            <button type="button" class="btn btn-shadow btn-outline-primary" @click="goback">뒤로가기</button>
        </div>
        <div class="form-side">
            <h6 class="mb-4 mt-4"> 개인정보 처리방침 </h6>
             <p>
          '㈜테이블엔조이'는(이하 '회사'는) 고객님의 개인정보를 중요시하며, "정보통신망 이용촉진 및 정보보호에 관한 법률”, “개인정보
          보호법” 등 관련 법령상 개인정보보호 규정을 준수하고 있습니다.
        </p>
        <br />
        <p>
          회사는 개인정보취급방침을 통하여 고객님께서 제공하시는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한
          조치가 취해지고 있는지 알려드립니다.
        </p>
        <br />
        <p>
          회사는 개인정보취급방침을 개정하는 경우 웹사이트, 모바일 어플리케이션, 공지사항(또는 개별공지)을 통하여 공지할 것입니다.
        </p>
        <br />
        <p>
          본 방침은 : 2016년 06월 08일부터 시행됩니다.
        </p>
        <br />
        <br />
        <strong>[목차]</strong>
        <br />
        <br />
        <p>
          1. 수집하는 개인정보의 항목 및 수집방법
        </p>
        <p>
          2. 개인정보의 수집 및 이용목적
        </p>
        <p>
          3. 수집한 개인정보의 보유 및 이용기간
        </p>
        <p>
          4. 제 3자에 대한 개인정보 제공
        </p>
        <p>
          5. 개인정보 처리의 위탁
        </p>
        <p>
          6. 이용자 및 법정대리인의 권리ㆍ의무 및 그 행사방법에 관한 사항
        </p>
        <p>
          7. 개인정보의 파기절차 및 방법
        </p>
        <p>
          8. 개인정보의 자동 수집 장치의 설치/운용 및 그 거부에 관한 사항
        </p>
        <p>
          9. 개인정보 보호책임자 및 담당자의 성명, 부서, 연락처
        </p>
        <p>
          10. 개인정보의 기술적/관리적 보호 대책
        </p>
        <p>
          11. 고지의 의무
        </p>
        <br />
        <br />
        <strong>1. 수집하는 개인정보의 항목 및 수집방법</strong>
        <br />
        <br />
        <p>
          회사는 회원가입, 상담, 서비스 신청 등을 위해 아래와 같은 개인정보를 수집하고 있습니다.
        </p>
        <br />
        <p>
          가. 개인정보 수집항목
        </p>
        <p>
          (1) 개인회원 수집항목
        </p>
        <p>
          - 필수항목 : 아이디, 비밀번호, 이름, E-Mail, 휴대폰번호,
        </p>
        <p>
          - 선택항목 : 성별, 연령대,
        </p>
        <p>
          - 자동수집항목 : IP Address, 기기정보, 서비스 이용기록 등
        </p>
        <p>
          (2) 비회원 수집항목
        </p>
        <p>
          - 선택항목 : 이름, 휴대폰, 결제비밀번호, 주소, 성별, 연령대, E-Mail
        </p>
        <p>
          - 자동수집항목 : IP Address, 기기정보, 서비스 이용기록 등
        </p>
        <p>
          (3) 협력업체 수집항목
        </p>
        <p>
          - 개인회원 수집항목 외
        </p>
        <p>
          - 회사명, 업종, 사업자등록번호, 대표자성명, 회사주소
        </p>
        <br />
        <p>
          나. 개인정보 수집방법
        </p>
        <p>
          (1) 홈페이지, 모바일 어플리케이션을 통한 회원가입, 예약시스템, 상담 게시판(고객센터), 전화상담
        </p>
        <p>
          (2) 이벤트페이지를 통한 입력
        </p>
        <p>
          (3) 상품구매 시 구매정보 입력
        </p>
        <p>
          (4) 제휴사로부터의 제공
        </p>
        <br />
        <br />
        <strong>2. 개인정보의 수집 및 이용목적</strong>
        <br />
        <br />
        <p>
          회사는 수집한 개인정보를 아래의 목적을 위해 활용합니다.
        </p>
        <br />
        <p>
          가. 이름, 계정, 비밀번호 : 서비스 이용에 따른 본인확인, 개인식별, 불량회원의 부정 이용 방지와 비인가 사용 방지 등 고객센터의
          운영을 위하여 사용됩니다.
        </p>
        <p>
          나. E-Mail, 전화번호, 휴대폰번호, 주소 : 고지사항 전달, 본인 의사확인, 불만처리 등 민원처리, 신상품, 이벤트 등 광고성
          정보안내, 경품 등 물품 배송 시 배송지 확인, 서비스 이용에 따른 본인확인
        </p>
        <p>
          다. 이용자의 IP주소, 방문 일시 : 불량회원의 부정 이용방지와 비인가 사용방지, 서비스 이용에 대한 통계학적 분석에 사용됩니다.
        </p>
        <p>
          라. 그 외 선택항목 : 개인맞춤서비스를 제공하기 위한 자료로 사용됩니다.
        </p>
        <br />
        <br />
        <strong>3. 수집한 개인정보의 보유 및 이용기간</strong>
        <br />
        <br />
        <p>
          회사는 개인정보 수집 및 이용목적이 달성된 후 또는 회원탈퇴 및 개인정보 해지요청 시에는 원칙적으로 해당 정보를 즉시 파기합니다. 단,
          아래의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다.
        </p>
        <br />
        <p>
          가. 내부 방침에 의한 정보보유 사유
        </p>
        <p>
          (1) 회원 ID
        </p>
        <p>
          - 보존 이유 : 서비스 이용의 혼선방지
        </p>
        <p>
          - 보존 기간 : 사업 종료 시까지
        </p>
        <br />
        <p>
          나. 관련 법령에 의한 정보보유 사유
        </p>
        <p>
          (1) 계약 또는 청약철회 등에 관한 기록 : 5년
        </p>
        <p>
          (2) 대금결제 및 재화 등의 공급에 관한 기록 : 5년
        </p>
        <p>
          (3) 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년
        </p>
        <p>
          (4) 보유기간을 이용자에게 미리 고지하거나 개별적으로 이용자의 동의를 받은 경우 : 고지하거나 개별 동의한 기간
        </p>
        <br />
        <br />
        <strong>4. 제 3자에 대한 개인정보 제공</strong>
        <br />
        <br />
        <p>
          회사는 고객님의 개인정보는 “02. 개인정보의 수집 및 이용목적”에서 고지한 범위 내에서 사용하며, 원칙적으로 서비스와 무관한 타
          기업, 기관에 제공하지 않습니다. 다만, 고객님의 개인정보를 제공하는 경우는 다음과 같습니다.
        </p>
        <br />
        <p>
          가. 이용자들이 사전에 동의한 경우
        </p>
        <br />
        <p>
          나. 법령에 의거하거나, 수사목적으로 법령에 정해진 절차와 방법에 따라 수사기관 또는 법원의 요구가 있는 경우 등 기타 법령에서 제
          3자 제공을 허용하는 경우
        </p>
        <br />
        <p>
          다. 회사가 제공하는 서비스를 통한 주문 및 결제 시 상담, 예약, 이벤트, 배송, 서비스 이용, 본인확인 등의 거래이행을 위하여
          판매자에게 정보 제공이 필요한 경우
        </p>
        <br />
        <p>
          [개인정보 제공내역 자세히보기]
        </p>
        <div>
          <br />
        </div>
        <div>
          <div>
            ◼︎ 모바일쿠폰 (e쿠폰) 제공업체
          </div>
          <div>
            - 제공목적: 서비스제공, 내역조회
          </div>
          <div>
            - 제공항목: 성명, 휴대폰번호 뒤 4자리
          </div>
          <div>
            - 보유 및 이용기간: 상품제공 완료 후 3개월
          </div>
          <div>
            <br />
          </div>
          <div>
            ◼︎ 배송상품 제공업체
          </div>
          <div>
            - 제공목적: 상품배송, 구매자확인, 해피콜
          </div>
          <div>
            - 제공항목: 성명, 전화번호, 주소, 휴대폰번호, 이메일
          </div>
          <div>
            - 보유 및 이용기간: 상품제공 완료 후 3개월
          </div>
          <div>
            <br />
          </div>
          <div>
            ◼︎ 예약 제공업체
          </div>
          <div>
            - 제공목적: 서비스제공, 본인확인, 해피콜
          </div>
          <div>
            - 제공항목: 성명, 휴대폰번호
          </div>
          <div>
            - 보유 및 이용기간: 서비스 제공 완료 후 즉시 삭제
          </div>
          <div>
            <br />
          </div>
          <div>
            ◼︎ 이벤트 제공업체
          </div>
          <div>
            - 제공목적: 경품발송, 본인확인
          </div>
          <div>
            - 제공항목: 성명, 휴대폰번호 뒤 4자리
          </div>
          <div>
            - 보유 및 이용기간: 경품발송 또는 서비스제공 완료 후 즉시 삭제
          </div>
          <div>
            <br />
          </div>
          <div>
            ◼︎ 특별 이벤트 제공업체
          </div>
          <div>
            - 제공목적: 경품발송, 본인확인, 해피콜
          </div>
          <div>
            - 제공항목: 성명, 주소, 휴대폰번호
          </div>
          <div>
            - 보유 및 이용기간: 경품발송 완료 후 즉시 삭제
          </div>
        </div>
        <div>
          <br />
        </div>
        <div>
          ※ 더 나은 서비스를 위하여 고객님의 개인정보를 협력업체등과 공유할 필요가 있는 경우에는 해당 내용을 이용자에게 고지하여 동의를
          구합니다.
          <br />
          <br />
          <br />
          <strong>5. 개인정보 처리의 위탁</strong>
          <br />
          <br />
          가. 회사는 보다 나은 서비스의 제공과 이용자의 편의 제공 등 원활한 업무 수행을 위해 이용자의 개인 정보를 타 업체에 수집, 보관,
          처리 등을 위탁하여 처리하고 있으며, 위 처리는 이용자가 동의한 개인정보의 이용 목적 범위 내에서 이루어집니다.
          <br />
          <br />
          나. 전 항에 따라 회사가 개인정보 처리를 위탁하는 업체 외에 개인정보의 처리를 위탁하는 경우에는 해당서비스 화면에 위탁자, 개인정보
          취급 위탁을 하는 업무의 내용에 관한 사항을 홈페이지를 통해 미리 고지하고 이용자로부터 별도의 동의를 받습니다.
          <br />
          <br />
          [ 개인정보 위탁 자세히보기]
        </div>
        <div>
          <div>
            ◼︎ ㈜처음소프트
          </div>
          <div>
            - 위탁업무 내용: 홍보메일 발송
          </div>
          <div>
            <br />
          </div>
          <div>
            ◼︎ ㈜케이피모바일
          </div>
          <div>
            - 위탁업무 내용: 홍보문자 발송
          </div>
          <div>
            <br />
          </div>
          <div>
            ◼︎ ㈜휴머스온
          </div>
          <div>
            - 위탁업무 내용: 이벤트 당첨 문자 발송
          </div>
          <div>
            <br />
          </div>
          <div>
            ◼︎ ㈜LG U+
          </div>
          <div>
            - 위탁업무 내용: 이벤트 당첨 문자 발송, SMS/LMS 문자발송
          </div>
          <div>
            <br />
          </div>
          <div>
            ◼︎ ㈜이니시스
          </div>
          <div>
            - 위탁업무 내용: 전자결제 대행
          </div>
          <div>
            <br />
          </div>
          <p>
            ※ 공유하는 정보는 당해 목적을 달성하기 위하여 필요한 최소한의 정보에 국한됩니다.
            <br />
          </p>
          ※ 직송 등 일부 배송형태에 따라, 전자상거래소비자보호법 제 21조에 의거 협력업체에 배송정보가 제공됩니다.
          <br />
          <br />
          <br />
          <strong>6. 이용자 및 법정대리인의 권리ㆍ의무 및 그 행사방법에 관한 사항</strong>
          <br />
          <br />
          가. 이용자 및 법정대리인은 언제든지 등록되어 있는 고객 혹은 당해 만 14세 미만 아동의 개인정보를 열람하거나 정정, 회원탈퇴를 하실
          수 있습니다.
          <br />
          (1) “TABLENJOY”사이트 고객센터 방문 : 로그인 후 “개인정보수정”을 클릭하여 개인정보 열람, 정정, 탈퇴
          <br />
          (2) 개인정보관리책임자에게 서면, 전화 또는 E-mail 로 연락하시면 지체 없이 조치하겠습니다.
          <br />
          <br />
          나. 고객이 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 또한
          잘못된 개인 정보를 제 3자에게 이미 제공한 경우에는 정정 처리 결과를 제 3자에게 지체 없이 통지하여 정정이 이루어지도록
          조치하겠습니다.
          <br />
          <br />
          다. 회사는 고객의 요청에 의해 해지 또는 삭제된 개인정보는 회사가 수집하는 개인정보의 보유 및 이용 기간에 명시된 바에 따라 처리하고
          그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.
          <br />
          <br />
          <br />
          <strong>7. 개인정보의 파기절차 및 방법</strong>
          <br />
          <br />
          회사는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 파기절차 및 방법은 다음과 같습니다.
          <br />
          <br />
          가. 파기절차
          <br />
          회원님이 회원가입 등을 위해 입력하신 정보는 목적이 달성된 후 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라 (보유 및
          이용기간 참조) 일정 기간 저장된 후 파기됩니다. 별도 DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 보유 이외의 다른
          목적으로 이용되지 않습니다. 단, 아이디의 경우는 서비스 혼선방지를 위해 유지됩니다.
          <br />
          <br />
          나. 파기방법
          <br />
          종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기하고 전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적
          방법을 사용하여 삭제합니다.
          <br />
          <br />
          <br />
          <strong>8. 개인정보의 자동 수집 장치의 설치/운용 및 그 거부에 관한 사항</strong>
          <br />
          <br />
          회사는 고객님의 정보를 수시로 저장하고 찾아내는 “쿠키(cookie)” 등을 운용합니다. 쿠키란 회사의 웹사이트를 운영하는데 이용되는
          서버가 고객님의 브라우저에 보내는 아주 작은 텍스트 파일로서 고객님의 컴퓨터 하드디스크에 저장됩니다.
          <br />
          <br />
          회사는 다음과 같은 목적을 위해 쿠키를 사용합니다.
          <br />
          <br />
          가. 쿠키 등 사용 목적
          <br />
          (1) 회원과 비회원의 접속 빈도나 방문 시간 등을 분석, 이용자의 취향과 관심분야를 파악 및 자취 추적,
          <br />
          (2) 각종 이벤트 참여 정도 및 방문 회수 파악 등을 통한 타겟 마케팅 및 개인 맞춤 서비스 제공
          <br />
          <br />
          나. 쿠키 설정 거부 방법
          <br />
          고객님는 쿠키 설치에 대한 선택권을 가지고 있습니다. 쿠키 설정을 거부하는 방법으로는 회원님이 사용하시는 웹 브라우저의 옵션을
          선택함으로써 모든 쿠키를 허용하거나 쿠키를 저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다.
          <br />
          <br />
          [쿠키거부 설정방법 (예: 인터넷 익스플로어의 경우)]
          <br />
          웹 브라우저 상단의 도구 &gt; 인터넷 옵션 &gt; 개인정보 탭 &gt; 개인정보취급 수준에서 설정 단, 고객님께서 쿠키 설치를
          거부하였을 경우 서비스 제공에 어려움이 있을 수 있습니다.
          <br />
          <br />
          <br />
          <strong>9. 개인정보 보호책임자 및 담당자의 소속-성명 및 연락처</strong>
          <br />
          <br />
          회사는 고객의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이 관련 부서 및 개인정보보호책임자를 지정하고
          있습니다.
          <br />
          <br />
          ▶ 개인정보보호책임자
          <br />
          성명 : 최종필
          <br />
          담당 부서 : 시스템개발팀
          <br />
          전화번호 : 02-6952-0853
          <br />
          이메일 : privacy@tablenjoy.com
          <br />
          <br />
          ▶ 개인정보처리 고충처리
          <br />
          담당 부서 : 고객지원팀
          <br />
          전화번호 : 02-6952-0852
          <br />
          이메일 : webmaster@tablenjoy.com
          <br />
          <br />
          고객님은 회사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보보호책임자 혹은 담당 부서로 신고하실 수 있습니다.
          <br />
          회사는 이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다.
          <br />
          <br />
          기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.
          <br />
          1) 개인분쟁조정위원회 (www.1336.or.kr / 1336)
          <br />
          2) 정보보호마크인증위원회 (www.eprivacy.or.kr / 02-580-0533~4)
          <br />
          3) 대검찰청 인터넷범죄수사센터 (http://icic.sppo.go.kr / 02-3480-3600)
          <br />
          4) 경찰청 사이버테러대응센터 (www.ctrc.go.kr / 02-392-0330)
          <br />
          <br />
          <br />
          <strong>10. 개인정보의 기술적/관리적 보호 대책</strong>
          <br />
          <br />
          회사는 이용자들의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 유출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은
          기술적/관리적 대책을 강구하고 있습니다.
          <br />
          <br />
          가. 비밀번호 암호화
          <br />
          회원 아이디(ID)의 비밀번호는 암호화되어 저장 및 관리되고 있습니다. 비밀번호는 오직 회원 본인만이 알고 있으며, 개인정보의 확인 및
          변경도 비밀번호를 알고 있는 본인에 의해서만 가능합니다.
          <br />
          <br />
          나. 해킹 등에 대비한 대책
          <br />
          회사는 해킹이나 컴퓨터 바이러스 등에 의해 회원의 개인정보가 유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다.
          <br />
          <br />
          개인정보의 훼손에 대비해서 자료를 수시로 백업하고 있고, 최신 백신프로그램을 이용하여 이용자들의 개인정보나 자료가 유출되거나 손상되지
          않도록 방지하고 있으며, 암호화통신 등을 통하여 네트워크상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다.
          <br />
          <br />
          그리고 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있으며, 기타 시스템적으로 보안성을 확보하기 위한 가능한 모든 기술적
          장치를 갖추려 노력하고 있습니다.
          <br />
          <br />
          다. 취급 직원의 최소화 및 교육
          <br />
          회사의 개인정보관련 취급 직원은 담당자에 한정시키고 있고 이를 위한 별도의 비밀번호를 부여하여 정기적으로 갱신하고 있으며, 담당자에
          대한 수시 교육을 통하여 개인정보취급방침의 준수를 항상 강조하고 있습니다.
          <br />
          <br />
          <br />
          <strong>11. 고지의 의무</strong>
          <br />
          <br />
          현 개인정보취급방침을 개정할 경우 시행 7일 전에 홈페이지 또는 이메일을 통해 사전 고지합니다. 다만, 개인정보의 수집 및 활용,
          제3자 제공 등과 같이 이용자 권리의 중요한 변경이 있을 경우에는 최소 30일 전에 고지합니다.
          <br />
          <br />
          이 정책은 아래 시행일자부터 시행됩니다.
          <br />
          <br />
          - 공고 일자 : 2010년 03월 25일
          <br />
          - 시행 일자 : 2010년 04월 01일
          <br />
          - 공고일자 : 2016년 06월 01일
          <br />
          - 시행일자 : 2016년 06월 08일
          <br />
        </div>
        </div>
    </b-card>
</div>
</template>

<script>
export default {
    data(){
        return{

        }
    },
    mounted(){

    },
    methods:{
        goback(){
            this.$router.back();
        }
    }
}
</script>

<style>

</style>
